import * as i0 from "@angular/core";
export class CalloutService {
    activateHover(callout) {
        if (this.activeHoverCallout) {
            this.activeHoverCallout.close();
        }
        this.activeHoverCallout = callout;
    }
}
CalloutService.ɵfac = function CalloutService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CalloutService)(); };
CalloutService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CalloutService, factory: CalloutService.ɵfac, providedIn: 'root' });
